import React from 'react'
import LexicalTextEditor from '@/components/inputs/TextEditor/LexicalTextEditor';
import styled from "styled-components";

const StyledHeader = styled.div`
  width: 100%;
  padding: 1rem 1.6rem;
  text-align: left;
  background: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Component = (props) => {
  return (
    <LexicalTextEditor
      key={props.value ? JSON.stringify(props.value) : 'no-value'}
      readOnly
      {...props}
      />
  )
}

export const optionDef = { display: "Rich Text", value: "richText", comp: 'LexicalTextDisplayWidget' }

export const defaultConfig = undefined; // could be some default props in this format: { props: {... } }

export const metaConfig = [
    {
      comp: 'TextInput',
      isRequired: true,
      valuePath: 'props.title',
      props: {
        label: 'Enter title'
      }
    },
    {
      comp: 'LexicalTextEditor',
      isRequired: true,
      valuePath: 'props.value',
      props: {
        label: 'Enter text'
      }
    },
  ]

export const processRawConfigFn = undefined; // check DataVizWidgetGeneratorV2 for reference on how to write this.